import { createTheme } from "@mui/material/styles";
import "./App.css";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#5956FF",
    },
    secondary: {
      main: "#0288D1",
    },
  },
});
